import { heroStats } from '@/mocks/animeData';

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[560px] md:min-h-[660px] flex items-center">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=artistic%20stylized%20anime%20city%20skyline%20at%20dusk%20with%20glowing%20lanterns%20and%20warm%20orange%20amber%20tones%2C%20painterly%20illustration%2C%20dramatic%20clouds%2C%20cinematic%20wide%20composition%2C%20high%20contrast%2C%20deep%20shadows%2C%20atmospheric&width=1920&height=1080&seq=hero-91anime-001&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/55 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 py-28 md:py-32">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 border border-background-50/25 text-background-50 text-xs md:text-sm">
            <i className="ri-fire-fill text-accent-400"></i>
            本期整理 · 热播 · 新番 · 完结神作
          </span>

          <h1 className="mt-6 font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight">
            91动漫：追番、找资源、看高清的一站式入口
          </h1>

          <p className="mt-5 text-base md:text-lg text-background-100 leading-relaxed max-w-2xl">
            首页把作品、类型与更新状态集中在一处：想按作品找就筛选，想直接开刷就看榜单，想同步追就跟着新番进度走。一页看完，不用反复搜地址。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#library"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-search-2-line"></i>
              进入作品速查库
            </a>
            <a
              href="#ranking"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-background-50/10 border border-background-50/40 text-background-50 text-sm md:text-base hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-bar-chart-2-line"></i>
              看本周热播榜
            </a>
          </div>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5 max-w-3xl">
          {heroStats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg bg-background-50/10 border border-background-50/20 backdrop-blur px-4 py-3 md:py-4"
            >
              <div className="font-heading text-2xl md:text-3xl font-bold text-accent-400">
                {stat.value}
              </div>
              <div className="mt-1 text-xs md:text-sm text-background-100">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 inset-x-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}